import { IMask } from "react-imask";

export const mask = (mask: string, value: string) => {
    const _mask = IMask.createMask({ mask });
    _mask.unmaskedValue = value;
    return _mask;
}
